import styled from 'styled-components';

const NavHeader = styled.nav`
  display: inline-block;
  font-size: 24px;
  margin: 0 8px;
`;

export default NavHeader;
